var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAuto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 26,
    viewBox: "0 0 50 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#F7F3EF",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M38.655 18.865c0 1.76 1.49 3.187 3.33 3.187 1.839 0 3.33-1.427 3.33-3.187 0-1.76-1.491-3.186-3.33-3.186-1.84 0-3.33 1.427-3.33 3.186z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M40.445 18.865c0 .814.69 1.474 1.54 1.474.85 0 1.54-.66 1.54-1.474 0-.813-.69-1.473-1.54-1.473-.85 0-1.54.66-1.54 1.473zM9.622 18.865c0 1.76 1.491 3.187 3.33 3.187 1.84 0 3.33-1.427 3.33-3.187 0-1.76-1.49-3.186-3.33-3.186-1.839 0-3.33 1.427-3.33 3.186z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.412 18.865c0 .814.69 1.474 1.54 1.474.85 0 1.54-.66 1.54-1.474 0-.813-.69-1.473-1.54-1.473-.85 0-1.54.66-1.54 1.473zM45.948 13.181v-2.87c0-.598-.46-1.104-1.077-1.188L31.827 7.34l-2.455-6.323c-.184-.474-.657-.788-1.185-.788H5.396c-.59 0-1.07.458-1.07 1.023v14.774h3.259l1.643-2.007c.224-.272.566-.431.928-.431h5.287c.474 0 .864.337 1.112.668l3.039 3.497h13.931l4.77-4.99c.207-.219.503-.344.813-.344h5.299c.248 0 .49.073.695.207l.846.555z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M9.889 8.305h7.722c.227 0 .412-.177.412-.395V4.18c0-.218-.185-.395-.412-.395H9.89c-.228 0-.413.177-.413.395V7.91c0 .218.185.395.413.395zM22.028 8.305h7.462c.285 0 .491-.26.415-.523L28.794 4.37c-.1-.346-.43-.586-.807-.586h-5.959c-.228 0-.412.177-.412.395V7.91c0 .218.184.395.412.395zM4.327 3.784h2.507c.228 0 .412.177.412.395V7.91c0 .217-.184.394-.412.394H4.327v-4.52zM1.261 14.401h3.066V5.03H1.193c-.527 0-.955.408-.955.912v7.482c0 .54.458.978 1.023.978zM47.48 11.031h-1.532v2.126h1.567c.263 0 .476-.204.476-.456v-1.18c0-.271-.228-.49-.51-.49z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M29.841 2.226H19.828v12.691c0 .444.376.804.84.804h10.136c.55 0 .996-.426.996-.952v-7.43l-1.959-5.113zM27.88 7.103L27.88 9.27M29.331 10.929L31.349 10.929M21.616 10.929L23.597 10.929M6.68 11.404L9.006 11.404M34.145 10.323V7.657L44.87 9.123c.618.084 1.077.59 1.077 1.188v.72H34.885c-.409 0-.74-.317-.74-.708zM29.331 13.672L31.349 13.672",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.396.228h22.79c.53 0 1.001.315 1.186.789l.47 1.21H4.326v-.975c0-.565.479-1.024 1.069-1.024zM36.618 18.865c0 2.837 2.403 5.136 5.367 5.136s5.367-2.3 5.367-5.136c0-2.836-2.403-5.135-5.367-5.135s-5.367 2.3-5.367 5.135zM7.585 18.865c0 2.837 2.403 5.136 5.367 5.136s5.367-2.3 5.367-5.136c0-2.836-2.403-5.135-5.367-5.135s-5.367 2.3-5.367 5.135z",
    transform: "translate(1 1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.102 12.626c-.205-.134-.447-.207-.695-.207h-5.3c-.31 0-.604.125-.813.343l-4.769 4.991H19.593l-3.038-3.497c-.274-.303-.638-.668-1.112-.668h-5.287c-.362 0-.704.16-.928.431l-1.643 2.007.627.433c.902-1.623 2.685-2.729 4.74-2.729 2.965 0 5.367 2.3 5.367 5.135 0 .297-.032.586-.082.869h4.936c0 .785.666 1.422 1.486 1.422h2.443c.85 0 1.539-.659 1.539-1.473l6.37-.05 1.652-.133c-.027-.208-.046-.42-.046-.635 0-2.836 2.404-5.135 5.368-5.135 1.113 0 2.146.324 3.003.879l.96-1.428-.846-.555z",
    transform: "translate(1 1)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuto);
export default __webpack_public_path__ + "static/media/auto.d775fc61833f6ff1e11b0a00c3927c79.svg";
export { ForwardRef as ReactComponent };